var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 11C21 9.02219 20.4135 7.08879 19.3147 5.4443C18.2159 3.79981 16.6541 2.51808 14.8268 1.7612C12.9996 1.00433 10.9889 0.806295 9.0491 1.19215C7.10929 1.578 5.32746 2.53041 3.92893 3.92893L11 11H21Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.92893 3.92893C2.05357 5.8043 1 8.34784 1 11C1 13.6522 2.05357 16.1957 3.92893 18.0711L11 11L3.92893 3.92893Z",
    fill: "#6FB1D6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.92893 18.0711C5.32746 19.4696 7.10929 20.422 9.0491 20.8079C10.9889 21.1937 12.9996 20.9957 14.8268 20.2388C16.6541 19.4819 18.2159 18.2002 19.3147 16.5557C20.4135 14.9112 21 12.9778 21 11H11L3.92893 18.0711Z",
    fill: "#DB5F7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCs);
export default __webpack_public_path__ + "static/media/cs.30bc82364fc453fc7f86335507312585.svg";
export { ForwardRef as ReactComponent };